module.exports = __webpack_public_path__ + "img/tt.c3647d9b.svg";